import { render, staticRenderFns } from "./demo-copy.vue?vue&type=template&id=64835318&scoped=true&"
import script from "./demo-copy.vue?vue&type=script&lang=js&"
export * from "./demo-copy.vue?vue&type=script&lang=js&"
import style0 from "./demo-copy.vue?vue&type=style&index=0&id=64835318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64835318",
  null
  
)

export default component.exports